export const locale = {
	lang: 'en',
	data: {
		'NOT_FOUND': {
			'TITLE': 'Page not found.'
		}
	}
};
